module.exports = __webpack_public_path__ + "media/images/ruuun-ccd5b1b9ca1fad90e5e385d9aafb683e.png";